import { Injectable, inject, signal } from "@angular/core";
import {
  ProviderClaimTypesGetDTO,
  ProviderClaimTypesCreateDTO,
  ProviderClaimTypesUpdateDTO,
} from "src/app/pages/providers/provider.model";
import { BaseCrudService } from "../generic/base.service";
import { catchError, Observable, of, tap, throwError } from "rxjs";
import { ToastService } from "src/app/shared/services/toast.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class ProviderClaimTypesService extends BaseCrudService<
  ProviderClaimTypesGetDTO[],
  ProviderClaimTypesCreateDTO,
  ProviderClaimTypesUpdateDTO,
  string
> {
  private toast = inject(ToastService);
  private translate = inject(TranslateService);

  providerClaimTypes = signal<ProviderClaimTypesGetDTO[]>([]);

  clearCache(): void {
    this.providerClaimTypes.set([]);
  }

  /** Returns cached claim types when available; otherwise loads from API. */
  getCachedOrLoad(): Observable<ProviderClaimTypesGetDTO[]> {
    const cached = this.providerClaimTypes();
    return cached.length > 0 ? of(cached) : this.get();
  }

  constructor() {
    super("/entity/provider_claim_type");
  }

  override get(
    id?: string,
    params?: Record<string, any>,
  ): Observable<ProviderClaimTypesGetDTO[]> {
    return super.get(id, params).pipe(
      tap((response) => {
        this.providerClaimTypes.set(response);
      }),
      catchError((error) => {
        this.toast.error(
          this.translate.instant("toast_errors.getProviderClaimTypesFailed"),
        );
        console.error("Error fetching provider claim types:", error);
        return throwError(() => error);
      }),
    );
  }
}
